import { createSelector } from 'reselect';
import { State } from 'store';

const getAuthState = (state: State) => state.auth;

// Raw store selectors
export const getAuthStatus = createSelector(getAuthState, entities => entities.status);
export const getAuthSuccess = createSelector(getAuthState, entities => entities.success);
